/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WebsiteNameQueryVariables = GraphQL.Exact<{
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type WebsiteNameQuery = { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly name: string | null } | null };


export const WebsiteNameDocument = gql`
    query WebsiteName($websiteId: WebsiteId!) {
  website(id: $websiteId) {
    id
    name
  }
}
    `;

/**
 * __useWebsiteNameQuery__
 *
 * To run a query within a React component, call `useWebsiteNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteNameQuery({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useWebsiteNameQuery(baseOptions: Apollo.QueryHookOptions<WebsiteNameQuery, WebsiteNameQueryVariables> & ({ variables: WebsiteNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteNameQuery, WebsiteNameQueryVariables>(WebsiteNameDocument, options);
      }
export function useWebsiteNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteNameQuery, WebsiteNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteNameQuery, WebsiteNameQueryVariables>(WebsiteNameDocument, options);
        }
export function useWebsiteNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteNameQuery, WebsiteNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteNameQuery, WebsiteNameQueryVariables>(WebsiteNameDocument, options);
        }
export type WebsiteNameQueryHookResult = ReturnType<typeof useWebsiteNameQuery>;
export type WebsiteNameLazyQueryHookResult = ReturnType<typeof useWebsiteNameLazyQuery>;
export type WebsiteNameSuspenseQueryHookResult = ReturnType<typeof useWebsiteNameSuspenseQuery>;
export type WebsiteNameQueryResult = Apollo.QueryResult<WebsiteNameQuery, WebsiteNameQueryVariables>;